/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionBrowserRefresh';

const ActionBrowserRefreshManager: ActionManagerFn<'ActionBrowserRefresh'> = (
  platform: Platform,
): ActionManager<'ActionBrowserRefresh'> => {
  return {
    ...baseActionManager(platform, 'ActionBrowserRefresh'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Browser Refresh',
    icon: { iconName: 'redo' },
    description: `**Overview**<br/>
The Browser Refresh action is a system-level utility component designed to initiate a full reload of the application. It functions by triggering the browser's native refresh mechanism, effectively reloading the current page and resetting the application state.<br/><br/>
This component is structurally simple, leveraging the standard action infrastructure without defining any custom properties. It serves as a direct bridge to the browser's reload functionality, identified visually in the editor by a 'redo' icon.

**Key Features**<br/>
* **Minimal Configuration:** Does not require or support any component-specific parameters, operating as a zero-configuration trigger.

**Use Cases**<br/>
* **Application Reset:** Forcing a complete reload of the application to clear all memory states or caches.
* **Session Recovery:** Restarting the application interface to resolve unresponsive states or apply updates that require a fresh load.`,
  };
};

export default ActionBrowserRefreshManager;
